// Product card video
//
// A card whose product has an uploaded video in its media gets a
// <video data-card-video> layered over the photo (snippets/card-product.liquid).
//
//   Desktop (a real mouse): plays while the pointer is over the card.
//   Touch screens: plays when the card is mostly in view and scrolling has
//   stopped; the first scroll or swipe pauses it again.
//
// Only one card plays at a time. Nothing downloads until a card is first
// played: the source waits in data-src. The video fades in on its first real
// frame and resets to the start when stopped, and because the videos begin and
// end on the product photo, both transitions are seamless.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var CARD = 'product-card';
  var VIDEO = 'video[data-card-video]';
  var REST_DELAY = 600; // ms of stillness before a touch card starts
  var VISIBLE_RATIO = 0.6; // share of the card that must be on screen

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  var current = null;

  function videoOf(card) {
    return card ? card.querySelector(VIDEO) : null;
  }

  // The card's image row can be swiped; only play over the main photo.
  function onFirstImage(card) {
    var scroller = card.querySelector('.product-card__media--swipeable');
    return !scroller || scroller.scrollLeft < 10;
  }

  function play(video) {
    if (current && current !== video) stop(current);
    current = video;
    if (!video.getAttribute('src')) {
      video.src = video.dataset.src;
      video.muted = true;
    }
    var promise = video.play();
    if (promise && promise.catch) promise.catch(function () {});
  }

  function stop(video) {
    video.classList.remove('is-playing');
    video.pause();
    if (current === video) current = null;
    // Rewind after the fade-out so the next play starts on the photo.
    setTimeout(function () {
      if (video.paused && video.readyState > 0) video.currentTime = 0;
    }, 400);
  }

  function onPlaying(event) {
    var video = event.target;
    if (video.matches && video.matches(VIDEO) && current === video) {
      video.classList.add('is-playing');
    }
  }
  document.addEventListener('playing', onPlaying, true);

  // The 720p file name is derived in Liquid; if it does not exist, use the
  // 1080p source Liquid reported.
  document.addEventListener('error', function (event) {
    var video = event.target;
    if (!video.matches || !video.matches(VIDEO)) return;
    var fallback = video.dataset.fallbackSrc;
    if (!fallback || video.getAttribute('src') === fallback) return;
    video.src = fallback;
    if (current === video) {
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function () {});
    }
  }, true);

  // ---- Desktop: hover ------------------------------------------------------
  if (canHover) {
    document.addEventListener('pointerover', function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      var card = event.target.closest && event.target.closest(CARD);
      if (!card || (event.relatedTarget && card.contains(event.relatedTarget))) return;
      var video = videoOf(card);
      if (video && onFirstImage(card)) play(video);
    });

    document.addEventListener('pointerout', function (event) {
      var card = event.target.closest && event.target.closest(CARD);
      if (!card || (event.relatedTarget && card.contains(event.relatedTarget))) return;
      var video = videoOf(card);
      if (video && current === video) stop(video);
    });

    // Using the image arrows means she wants the photos, not the video.
    document.addEventListener('click', function (event) {
      if (!event.target.closest || !event.target.closest('.product-card__nav-arrow')) return;
      var video = videoOf(event.target.closest(CARD));
      if (video && current === video) stop(video);
    }, true);
    return;
  }

  // ---- Touch: play the card at rest ----------------------------------------
  if (saveData || !('IntersectionObserver' in window)) return;

  var ratios = new Map();
  var restTimer = null;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      ratios.set(entry.target, entry.intersectionRatio);
    });
  }, { threshold: [0, 0.25, 0.5, VISIBLE_RATIO, 0.75, 1] });

  function observeCards(root) {
    (root.querySelectorAll ? root.querySelectorAll(CARD) : []).forEach(function (card) {
      if (card.dataset.cardVideoObserved || !videoOf(card)) return;
      card.dataset.cardVideoObserved = 'true';
      observer.observe(card);
    });
  }

  // The card closest to the middle of the screen wins.
  function pickCard() {
    var best = null;
    var bestDistance = Infinity;
    var middle = window.innerHeight / 2;
    ratios.forEach(function (ratio, card) {
      if (ratio < VISIBLE_RATIO || !card.isConnected || !onFirstImage(card)) return;
      var rect = card.getBoundingClientRect();
      var distance = Math.abs(rect.top + rect.height / 2 - middle);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = card;
      }
    });
    return best;
  }

  function onMove() {
    if (current) stop(current);
    clearTimeout(restTimer);
    restTimer = setTimeout(function () {
      var card = pickCard();
      if (card) play(videoOf(card));
    }, REST_DELAY);
  }

  // Capture phase so a horizontal swipe through a card's images counts too.
  window.addEventListener('scroll', onMove, { passive: true, capture: true });
  window.addEventListener('touchstart', function () {
    if (current) stop(current);
    clearTimeout(restTimer);
  }, { passive: true });
  window.addEventListener('touchend', onMove, { passive: true });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden && current) stop(current);
  });

  function init() {
    observeCards(document);
    // Filters, sorting and "load more" re-render the product grid.
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches(CARD)) observeCards(node.parentNode);
          else observeCards(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
    onMove();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
